import { render, staticRenderFns } from "./nationalGames_NSG.vue?vue&type=template&id=2eb6154e"
import script from "./nationalGames_NSG.vue?vue&type=script&lang=js"
export * from "./nationalGames_NSG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports